/* eslint-disable no-alert, no-console */ /* eslint-disable no-duplicate-imports */
/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '../../client'
import type { RequestConfig, ResponseErrorConfig } from '../../client'
import type { GetApiUsersCurrentQueryResponse } from '../models/GetApiUsersCurrent'

function getGetApiUsersCurrentUrl() {
  return `/api/users/current.json` as const
}

/**
 * @description Danish: Hent nuværende bruger
 * {@link /api/users/current.json}
 */
export async function getApiUsersCurrent(config: Partial<RequestConfig> & { client?: typeof client } = {}) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<GetApiUsersCurrentQueryResponse, ResponseErrorConfig<Error>, unknown>({
    method: 'GET',
    url: getGetApiUsersCurrentUrl().toString(),
    ...requestConfig,
  })
  return res.data
}